import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../context/AuthContext";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Divider,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import HomeIcon from "@mui/icons-material/Home";
import CurrencyRupeeSharpIcon from "@mui/icons-material/CurrencyRupeeSharp";
import SettingsIcon from "@mui/icons-material/Settings";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Toolbar, Typography, FormControlLabel } from "@mui/material";
import Collapse from "@mui/material/Collapse";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { ExpandLess, ExpandMore, ManageAccounts } from "@mui/icons-material";
import { styled, useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Switch from "@mui/material/Switch";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import "../Assets/Styles/Style.css";
import ManualTransaction from "../pages/manage/ManualTransaction";

import FlashTransaction from "../pages/manage/FlashTransaction";
import DailyTransaction from "../pages/manage/DailyTransaction";
import CashTransaction from "../pages/manage/CashTransaction";
import useApi from "../utils/useApi";

const drawerWidth = 240;
const AppBarWithDrawer = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));
const Header = () => {
  const { user } = useContext(AuthContext);
  const { logOutUser } = useContext(AuthContext);
  const [isCollapse, setIsCollapse] = useState(false);
  const [open, setOpen] = useState(false);
  const [profile, setProfile] = useState(null);
  const [openDialogue, setOpenDialogue] = useState(false);
  const [openTransaction, setOpenTransaction] = useState(false);
  const [openFlash, setOpenFlash] = useState(false);
  const [openCash, setOpenCash] = useState(false);
  const [currentDate, setCurrentDate] = useState("");
  const [isDrvSup, setIsDrvSup] = useState(false);
  const [switchChecked, setSwitchChecked] = useState(false);
  const [screenshotUploadEnabled, setScreenshotUploadEnabled] = useState(true);
  const [systemErr, setSystemErr] = useState();
  const { Get } = useApi();
  const theme = useTheme();
  const handleMenu = (event) => {
    setProfile(event.currentTarget);
  };

  const handleClose = () => {
    setProfile(null);
  };
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const handleCollapse = (section) => {
    setIsCollapse(section === isCollapse ? null : section);
  };

  const handleClickFlash = () => {
    setOpenFlash(true);
  };

  const handleClosFlash = () => {
    setOpenFlash(false);
  };

  const handleClickOpen = () => {
    setOpenDialogue(true);
  };

  const handleCloseDialogue = () => {
    setOpenDialogue(false);
  };

  const handleOpenCashTransaction = () => {
    setOpenCash(true);
  };

  const handleCloseCashTransaction = () => {
    setOpenCash(false);
  };

  const handleDailyTransaction = () => {
    setOpenTransaction(true);
  };

  const handleCloseTransaction = () => {
    setOpenTransaction(false);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (open && !event.target.closest(".MuiDrawer-root")) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [open]);
  useEffect(() => {
    checkCurrentMobilePaymentStatus();
    checkScreenshotUploadStatus();
    const today = new Date();
    const date = `${today.getDate()}/${today.getMonth() + 1
      }/${today.getFullYear()}`;
    setCurrentDate(date);
    isDrvSupUsr().then((resp) => {

      setIsDrvSup(resp.is_dhruv_inv);
    });

    checkSystemIssue().then((resp) => {
      setSystemErr(resp);
      console.log(resp);
    });
  }, []);

  let isDrvSupUsr = async () => {
    return await Get("isSuperUser");
  };

  let checkSystemIssue = async () => {
    return await Get("systemCheck");
  };


  let checkCurrentMobilePaymentStatus = async () => {
    const response = await Get("checkMobilePaymentStatus");
    if (response.results[0].value.toLowerCase() == "true") {
      setSwitchChecked(true);
    } else {
      setSwitchChecked(false);
    }
  }

  let checkScreenshotUploadStatus = async () => {
    try {
      const response = await Get("checkScreenshotUploadStatus");
      if (response.results[0].value.toLowerCase() == "true") {
        setScreenshotUploadEnabled(true);
      } else {
        setScreenshotUploadEnabled(false);
      }
    } catch (error) {
      console.log("Screenshot upload status check failed", error);
    }
  }

  const handleSwitchChange = async () => {
    await Get('toggleMobilePayment');
    if (switchChecked) {
      setSwitchChecked(false);
    } else {
      setSwitchChecked(true);
    }
  };

  const handleToggleScreenshotUpload = async () => {
    try {
      await Get('toggleScreenshotUpload');
      if (screenshotUploadEnabled) {
        setScreenshotUploadEnabled(false);
      } else {
        setScreenshotUploadEnabled(true);
      }
    } catch (error) {
      console.log("Failed to toggle screenshot upload", error);
    }
  };




  let printSysErr = (error) => {
    return (
      <AppBar
        position="relative"
        color="default"
        style={{
          top: 120,
          backgroundColor: "#",
          left: "5%",
          borderRadius: "20px",
          width: "90%",

          padding: "20px",
        }}
      >
        <div className="row">
          <div className="col-md-1">
            <img src="assets/img/error.gif" height="80px" />
          </div>
          <div className="col-md-7">
            <h4>System check found some issue!</h4>
            <h6>Please fix this issues as soon as possible!</h6></div>
        </div>
        <div className="row" style={{ border: "1px dashed pink" }}>
          {Reflect.ownKeys(error).includes("account") ? (
            <div className="col-md-3">
              <Link to="/account">Fix Account</Link>

              {error.account.map((k, index) => {
                return <p key={index}>{k.err}</p>;
              })}
            </div>
          ) : (
            ""
          )}

          {Reflect.ownKeys(error).includes("holiday") ? (
            <div className="col-md-3">
              <Link to="/holiday">Fix Holiday</Link>
              {error.holiday.map((k, index) => {
                return <p key={index}>{k.err}</p>;
              })}
            </div>
          ) : (
            ""
          )}

          {Reflect.ownKeys(error).includes("role") ? (
            <div className="col-md-3">
              <Link to="/role">Fix Roles</Link>
              {error.role.map((k, index) => {
                return <p key={index}>{k.err}</p>;
              })}
            </div>
          ) : (
            ""
          )}

          {Reflect.ownKeys(error).includes("key") ? (
            <div className="col-md-3">
              <Link to="/appenv">Fix Env Keys</Link>
              {error.key.map((k, index) => {
                return <p key={index}>{k.err}</p>;
              })}
            </div>
          ) : (
            ""
          )}

          {Reflect.ownKeys(error).includes("customer_charge") ? (
            <div className="col-md-3">
              <Link to="/appenv">Fix Customer Charge</Link>
              {error.customer_charge.map((k, index) => {
                return <p key={index}>{k.err}</p>;
              })}
            </div>
          ) : (
            ""
          )}
        </div>
      </AppBar>
    );
  };

  return (
    <div sx={{ display: "flex" }}>
      <AppBarWithDrawer
        position="fixed"
        open={open}
        style={{ backgroundColor: "#35424a" }}
      >
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            sx={{ mr: 2, ...(open && { display: "none" }) }}
          >
            <MenuIcon />
          </IconButton>
          <div style={{ display: "flex", alignItems: "center" }}>
            {isDrvSup ? (
              <img
                src={"./assets/img/cash-money.png"}
                alt="Logo"
                style={{ height: 70, marginRight: 10 }}
              />
            ) : (
              <img
                src={"./assets/img/logo/PIC_Logo.svg"}
                alt="Logo"
                style={{ height: 70, marginRight: 10 }}
              />
            )}
            <Typography variant="h6" noWrap component="div">
              {isDrvSup ? "Dhruv Investment Co" : "P.Chandra Investment Co"}
            </Typography>
          </div>
          <div style={{ flexGrow: 1 }} />
          <FormControlLabel
            control={
              <Switch checked={screenshotUploadEnabled} onChange={handleToggleScreenshotUpload} />
            }
            label={screenshotUploadEnabled ? "Disable screenshot upload" : "Enable screenshot upload"}
            labelPlacement="start"
          />
          &nbsp;&nbsp;
          <FormControlLabel
            control={
              <Switch checked={switchChecked} onChange={handleSwitchChange} />
            }
            label={switchChecked ? "Disable mobile payment" : "Enable mobile payment"}
            labelPlacement="start"
          />
          <Button variant="contained" onClick={handleOpenCashTransaction}>
            <img src="assets/img/cash(1).png" height="25px" />
            Cash Transaction
          </Button>
          <Dialog
            open={openCash}
            onClose={handleCloseCashTransaction}
            maxWidth="lg"
          >
            <DialogTitle>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>
                  <img
                    src="assets/img/cash(1).png"
                    height="50px"
                    alt="cash icon"
                  />
                  &nbsp;&nbsp; Cash Transaction
                </div>
                <div>{currentDate}</div>
              </div>
            </DialogTitle>
            <DialogContent>
              <CashTransaction />
            </DialogContent>
          </Dialog>
          <Button variant="contained" onClick={handleDailyTransaction}>
            <img src="assets/img/today1.png" height="25px" />
            Today Transaction
          </Button>
          <Dialog
            open={openTransaction}
            onClose={handleCloseTransaction}
            maxWidth="lg"
          >
            <DialogTitle>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>
                  <img src="assets/img/today1.png" height="50px" />
                  &nbsp;&nbsp; Today Transaction &nbsp;&nbsp;
                </div>
                <div>{currentDate}</div>
              </div>
            </DialogTitle>
            <DialogContent>
              <DailyTransaction />
            </DialogContent>
          </Dialog>
          <Button variant="contained" onClick={handleClickFlash}>
            <img src="assets/img/flash.png" height="25px" />
            Flash Transaction
          </Button>
          <Dialog open={openFlash} onClose={handleClosFlash} maxWidth="lg">
            <DialogTitle>
              <img src="assets/img/flash.png" height="50px" />
              &nbsp;&nbsp;Flash Transaction
            </DialogTitle>
            <DialogContent>
              <FlashTransaction isOpen={openFlash} />
            </DialogContent>
          </Dialog>
          <Button variant="contained" onClick={handleClickOpen}>
            <img src="assets/img/manual.png" height="25px" /> &nbsp;Manual
            Transaction
          </Button>
          <Dialog
            open={openDialogue}
            onClose={handleCloseDialogue}
            maxWidth="lg"
          >
            <DialogTitle>
              {" "}
              <img src="assets/img/manual.png" height="50px" /> &nbsp;&nbsp;
              Manual Transaction
            </DialogTitle>
            <DialogContent>
              <ManualTransaction />
            </DialogContent>
          </Dialog>
          <div>
            <IconButton
              size="small"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              className="icon-button"
              style={{ color: "white" }}
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={profile}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(profile)}
              onClose={handleClose}
              PaperProps={{
                style: {
                  backgroundColor: "#35424a",
                  width: "190px",
                },
              }}
            >
              <MenuItem
                onClick={handleClose}
                className="menu-item-list blue-text"
              >
                {`Hello, ${user.phone_no}`}
              </MenuItem>
              <MenuItem
                onClick={logOutUser}
                className="menu-item-list red-text"
              >
                Logout
              </MenuItem>
            </Menu>
          </div>
          {/* end menu item */}
        </Toolbar>
      </AppBarWithDrawer>
      <AppBar
        position="fixed"
        color="default"
        style={{ top: 64, backgroundColor: "#6c757d", height: 45 }}
      >
        <Toolbar style={{ justifyContent: "center", minHeight: 45 }}>
          <Button component={Link} to="/" className="custom-link">
            Home
          </Button>
          <Button component={Link} to="/group" className="custom-link">
            Group
          </Button>
          <Button component={Link} to="/subscription" className="custom-link">
            Subscription
          </Button>
          <Button component={Link} to="/transaction" className="custom-link">
            Transaction
          </Button>
          <Button component={Link} to="/users" className="custom-link">
            User
          </Button>
          <Button component={Link} to="/screenshot" className="custom-link">
            PayManagement
          </Button>
          <Button component={Link} to="/settlement" className="custom-link">
            settlement
          </Button>
          <Button component={Link} to="/csv-migrator" className="custom-link">
            CSV Migrator
          </Button>
          {/* <Button component={Link} to="/migration-logs" className="custom-link">
            Migration Logs
          </Button> */}
          {/* <Button component={Link} to="/csv-demigrator" className="custom-link">
            CSV Demigrator
          </Button>
          <Button component={Link} to="/csv-verifier" className="custom-link">
            CSV Verifier
          </Button> */}
          {/* <Button component={Link} to="/recent-changes" className="custom-link">
            Recent Changes
          </Button> */}
        </Toolbar>
      </AppBar>
      {(systemErr) ? (Object.entries(systemErr).length > 0) ? printSysErr(systemErr) : "" : ""}
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            backgroundColor: " #6c757d",
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <DrawerHeader>
          {/* <Typography variant="h6" noWrap component="div">
           Admin Panel
           </Typography>  */}
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List style={{ color: "white" }}>
          <ListItem
            button
            component={Link}
            to="/"
            className="list-item"
            onClick={() => setOpen(!open)}
          >
            <ListItemIcon>
              <HomeIcon className="icon-sidebar" />
            </ListItemIcon>
            <ListItemText primary="Home" className="list-item-text" />
          </ListItem>
          <ListItem
            button
            onClick={() => handleCollapse("Manage App")}
            className="list-item"
          >
            <ListItemIcon>
              <ManageAccounts className="icon-sidebar" />
            </ListItemIcon>
            <ListItemText primary="Manage App" />
            {isCollapse === "Manage App" ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse
            in={isCollapse === "Manage App"}
            timeout="auto"
            unmountOnExit
          >
            <List component="div" disablePadding>
              <ListItem
                button
                component={Link}
                to="/group"
                className="list-item"
                onClick={() => setOpen(!open)}
              >
                <ListItemText
                  inset
                  primary="Group"
                  className="list-item-text"
                />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/subscription"
                className="list-item"
                onClick={() => setOpen(!open)}
              >
                <ListItemText
                  inset
                  primary="Subscription"
                  className="list-item-text"
                />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/investment"
                className="list-item"
                onClick={() => setOpen(!open)}
              >
                <ListItemText
                  inset
                  primary="Investment"
                  className="list-item-text"
                />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/draw"
                className="list-item"
                onClick={() => setOpen(!open)}
              >
                <ListItemText inset primary="Draw" className="list-item-text" />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/winner"
                className="list-item"
                onClick={() => setOpen(!open)}
              >
                <ListItemText
                  inset
                  primary="Winner"
                  className="list-item-text"
                />
              </ListItem>
            </List>
          </Collapse>
          <ListItem
            button
            onClick={() => handleCollapse("Accounting")}
            className="list-item"
          >
            <ListItemIcon>
              <CurrencyRupeeSharpIcon className="icon-sidebar" />
            </ListItemIcon>
            <ListItemText primary="Accounting" />
            {isCollapse === "Accounting" ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse
            in={isCollapse === "Accounting"}
            timeout="auto"
            unmountOnExit
          >
            <List disablePadding>
              <ListItem
                button
                component={Link}
                to="/account"
                className="list-item"
                onClick={() => setOpen(!open)}
              >
                <ListItemText
                  inset
                  primary="Account"
                  className="list-item-text"
                />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/transaction"
                className="list-item"
                onClick={() => setOpen(!open)}
              >
                <ListItemText
                  inset
                  primary="Transaction"
                  className="list-item-text"
                />
              </ListItem>

              <ListItem
                button
                component={Link}
                to="/paymentgateway"
                className="list-item"
                onClick={() => setOpen(!open)}
              >
                <ListItemText
                  inset
                  primary="Payment Gateway"
                  className="list-item-text"
                />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/sms"
                className="list-item"
                onClick={() => setOpen(!open)}
              >
                <ListItemText
                  inset
                  primary="Balance Sheet"
                  className="list-item-text"
                />
              </ListItem>
            </List>
          </Collapse>
          <ListItem
            button
            onClick={() => handleCollapse("Settings")}
            className="list-item"
          >
            <ListItemIcon>
              <SettingsIcon className="icon-sidebar" />
            </ListItemIcon>
            <ListItemText primary="Settings" />
            {isCollapse === "Settings" ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={isCollapse === "Settings"} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                button
                component={Link}
                to="/users"
                className="list-item"
                onClick={() => setOpen(!open)}
              >
                <ListItemText
                  inset
                  primary="Users"
                  className="list-item-text"
                />
              </ListItem>
              {/* <ListItem
                button
                component={Link}
                to="/status"
                className="list-item"
                 onClick={() => setOpen(!open)}
              >
                <ListItemText
                 
                  inset
                  primary="Status"
                  className="list-item-text"
                />
              </ListItem> */}
              <ListItem
                button
                component={Link}
                to="/role"
                className="list-item"
                onClick={() => setOpen(!open)}
              >
                <ListItemText inset primary="Role" className="list-item-text" />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/personalinfo"
                className="list-item"
                onClick={() => setOpen(!open)}
              >
                <ListItemText
                  inset
                  primary="Personal info"
                  className="list-item-text"
                />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/sms"
                className="list-item"
                onClick={() => setOpen(!open)}
              >
                <ListItemText
                  inset
                  primary="SMS Service"
                  className="list-item-text"
                />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/homealert"
                className="list-item"
                onClick={() => setOpen(!open)}
              >
                <ListItemText
                  inset
                  primary="Home Alert"
                  className="list-item-text"
                />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/holiday"
                className="list-item"
                onClick={() => setOpen(!open)}
              >
                <ListItemText
                  inset
                  primary="Holiday"
                  className="list-item-text"
                />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/appenv"
                className="list-item"
                onClick={() => setOpen(!open)}
              >
                <ListItemText
                  inset
                  primary="App Env"
                  className="list-item-text"
                />
              </ListItem>
            </List>
          </Collapse>
          <ListItem
            button
            onClick={() => handleCollapse("Support")}
            className="list-item"
          >
            <ListItemIcon>
              <ContactSupportIcon className="icon-sidebar" />
            </ListItemIcon>
            <ListItemText primary="Support" />
            {isCollapse === "Support" ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={isCollapse === "Support"} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                button
                component={Link}
                to="/customer-queries"
                className="list-item"
                onClick={() => setOpen(!open)}
              >
                <ListItemText
                  inset
                  primary="Customer queries"
                  className="list-item-text"
                />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/faq"
                className="list-item"
                onClick={() => setOpen(!open)}
              >
                <ListItemText inset primary="FAQ" className="list-item-text" />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/documents"
                className="list-item"
                onClick={() => setOpen(!open)}
              >
                <ListItemText
                  inset
                  primary="Policy Documents"
                  className="list-item-text"
                />
              </ListItem>

            </List>
          </Collapse>
        </List>
      </Drawer>
    </div>
  );
};
export default Header;
